import { render, staticRenderFns } from "./NoteForm.vue?vue&type=template&id=0fedae61&scoped=true"
import script from "./NoteForm.vue?vue&type=script&lang=js"
export * from "./NoteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fedae61",
  null
  
)

export default component.exports